import { observable } from "mobx";

/**
 * BranchViewEventModel defines event for racing braches.
 *
 * @typedef BranchViewEventModel
 * @type {Object}
 * @property {id} Unique identifier
 * @property {dateTime} Date of current Branch View event
 * @property {url} String seo url of current Branch View event
 * @property {title} Title ( starting time ) of current Branch View event
 * @property {racingStateId} ID of status for current Branch View event
 * @property {handler} Onclick handler of current BranchView Event
 */

export class BranchViewEventModel {
    id: string;
    dateTime: Date;
    title?: string;
    @observable url?: string;
    @observable raceProgress: number;
    handler?: any;

    constructor(source: BranchViewEventModel) {
        this.id = source.id;
        this.url = source.url
        this.dateTime = source.dateTime;
        this.title = `${this.dateTime.formatDate("HH:mm")}`;
        this.raceProgress = source.raceProgress;
        this.handler = source.handler;
    }
}